import { jsx as _jsx } from "react/jsx-runtime";
import * as THREE from 'three';
import { usePrimitiveHelper, correctHelperForParentGroup } from '../../../../r3f/hooks/useTHREEHelper';
import { useGizmoDrawn } from '../../../../r3f/hooks/useGizmoState';
const HELPER_COLOR = 0xffff00;
const DIRECTIONAL_HELPER_SIZE = 1.0;
const POINT_HELPER_SIZE = 0.25;
/**
 * Renders any THREE light helper as a `<primitive>`. `make` builds the helper
 * once the light's ref resolves, and `usePrimitiveHelper` updates and disposes
 * it. No ref or a closed gate tears down whatever was mounted.
 */
function LightGizmoCommon(props) {
    const visible = useGizmoDrawn('selected-only');
    const helper = usePrimitiveHelper(() => {
        if (!visible)
            return null;
        const light = props.lightRef.current;
        return light ? props.make(light) : null;
    }, [props.lightRef, visible]);
    return helper ? _jsx("primitive", { object: helper }) : null;
}
export function DirectionalLightGizmo({ lightRef }) {
    return (_jsx(LightGizmoCommon, { lightRef: lightRef, make: (light) => {
            const helper = new THREE.DirectionalLightHelper(light, DIRECTIONAL_HELPER_SIZE, HELPER_COLOR);
            return correctHelperForParentGroup(helper, light);
        } }));
}
export function PointLightGizmo({ lightRef }) {
    return (_jsx(LightGizmoCommon, { lightRef: lightRef, make: (light) => {
            // THREE.PointLightHelper has DirectionalLightHelper's `matrix =
            // light.matrixWorld` aliasing, so it takes the same correction
            // (`r3f/hooks/useTHREEHelper.ts`).
            const helper = new THREE.PointLightHelper(light, POINT_HELPER_SIZE, HELPER_COLOR);
            return correctHelperForParentGroup(helper, light);
        } }));
}
export function SpotLightGizmo({ lightRef }) {
    return (_jsx(LightGizmoCommon, { lightRef: lightRef, make: (light) => new THREE.SpotLightHelper(light, HELPER_COLOR) }));
}
//# sourceMappingURL=lightHelpers.js.map